import { render } from "./MarginTile.vue?vue&type=template&id=68a618f6&scoped=true"
import script from "./MarginTile.vue?vue&type=script&lang=js"
export * from "./MarginTile.vue?vue&type=script&lang=js"

import "./MarginTile.vue?vue&type=style&index=0&id=68a618f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68a618f6"]])

export default __exports__